import { KMatrixColumnConfig } from "../../components/amrPipeline/types/KMatrixColumnConfig";
import { OriginatingTransactionClass } from "../../types/amr-pipeline/models/OriginatingTransactionClass";
import { formatUtils, amrFormatUtils } from "../../utils";
import { getDMValueFromClass } from "../../utils/amr-pipeline.utils";
import { TransactionStatus } from "../../types/amr-pipeline/enums/TransactionStatus";

export const kMatrixValuesColumnsConfigs: Record<string, KMatrixColumnConfig> = {
    guidance: {
        title: 'DM',
        key: 'guidance',
        getValue: (tc: OriginatingTransactionClass, transactionStatus?: TransactionStatus) => getDMValueFromClass(tc, transactionStatus),
    },
    parSubordination: {
        title: 'C/E, %',
        key: 'parSubordination',
        getValue: (tc: OriginatingTransactionClass) =>
            tc.parSubordination ? formatUtils.formatDecimal(tc.parSubordination) : null,
    },
    mvoc: {
        title: 'MVOC, %',
        key: 'mvoc',
        getValue: (tc: OriginatingTransactionClass) =>
            tc.mvoc ? formatUtils.formatDecimal(tc.mvoc) : null,
    },
    rating: {
        title: 'Rtg (M/S/F/K/D)',
        key: 'rating',
        getValue: amrFormatUtils.formatKMatrixRating,
        getTooltipValue: amrFormatUtils.formatRating,
    },
} as const;
